import { Loader2 } from "lucide-react";

const Loader = ({ label = "Loading...", fullScreen = true }) => {
	const Wrapper = fullScreen ? "div" : "span";

	return (
		<Wrapper className={fullScreen ? "min-h-[50vh] flex items-center justify-center" : "inline-flex items-center justify-center"}>
			<div className="flex flex-col items-center gap-3 text-muted-foreground">
				<div className="relative">
					<div className="h-12 w-12 rounded-full border-2 border-primary/20 border-t-primary animate-spin" />
					<Loader2 className="h-6 w-6 text-primary absolute inset-0 m-auto animate-spin-slow" />
				</div>
				<p className="text-sm font-medium tracking-wide">{label}</p>
				<p className="text-xs text-muted-foreground/80">
					Getting your game ready to play
				</p>
			</div>
		</Wrapper>
	);
};

export default Loader;
